module.exports = __webpack_public_path__ + "static/scale-model-of-the-lion-lighthouse-in-long-beach-california-19bf1738900fed561ca7c081b94637a0.png";